<template>
    <div v-if="isMounted">
        <app-header></app-header>
        <app-sidebar></app-sidebar>
        <app-tab></app-tab>
        <div class="page-wrapper" :style="{'height':(clientHeight-76)+'px'}">
            <keep-alive>
                <router-view :key="key" :ref="key"></router-view>
            </keep-alive>
        </div>
        <app-modal ref="modal"></app-modal>
    </div>
</template>

<style scoped>
    .page-wrapper {
        margin-left: 59px;
        padding: 10px;
    }
</style>

<script>
    import AppHeader from '@/layouts/Header'
    import AppSidebar from '@/layouts/Sidebar'
    import AppTab from '@/layouts/Tab'
    import Modal from '@/modal/Modal.vue'

    export default {
        name: "Dashboard",
        data() {
            return {
                path: "/user/base",
                ops: {
                    rail: {
                        size: '3px',
                        gutterOfSide: '5px'
                    },
                    bar: {
                        background: '#161931'
                    }
                },
                currentUsers: [],
                cached: ['students-list', 'returnVisit-list'],
                isMounted: false,
                show: true,
            }
        },
        components: {
            'app-tab': AppTab,
            'app-header': AppHeader,
            'app-sidebar': AppSidebar,
            'app-modal': Modal
        },
        computed: {
            // cached() {
            //     let a = [];
            //     this.$store.state.tagsView.cachedViews.forEach(item => {
            //         a.push(item)
            //     });
            //     console.log(a);
            //     return a;
            // },
            cachedViews() {
                return this.$store.state.tagsView.cachedViews;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight;
            },
            key() {
                return this.$route.path;
                if (this.$route.path==='/student/register'){
                    return this.$route.path;
                }
                if (this.$route.path==='/timetable/semester'){
                    return this.$route.path;
                }
                return this.$route.path + Math.random();
            }
        },
        created() {
        },
        mounted() {
            this.$wApi.addListen(this.path, this.handleData);
            this.$wApi.send(this.path, 'init', {});
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.$store.commit('setPowers', {'powers': data.powers});
                        this.$store.commit('setSemester', {'semester': data.nowSemester});
                        this.$store.commit('setSection', {'section': data.section});
                        this.$store.commit('setSections', {'sections': data.sections});
                        this.$store.commit('setConfig', {'config': data.config});
                        this.$store.commit('windowsConfig',
                            {
                                'clientHeight': `${document.documentElement.clientHeight}`,
                                'clientWidth': `${document.documentElement.clientWidth}`
                            });

                        const that = this;
                        window.onresize = function temp() {
                            that.$store.commit('windowsConfig',
                                {
                                    'clientHeight': `${document.documentElement.clientHeight}`,
                                    'clientWidth': `${document.documentElement.clientWidth}`
                                });
                        };
                        this.$store.commit('setCurrentUsers', {'currentUsers': data.currentUsers});
                        this.isMounted = true;
                        break;
                    case 'update_powers':
                        if (this.$store.state.config.section.id == data.section_id) {
                            this.$store.commit('setPowers', {'powers': data.powers});
                        }
                        break;
                    case 'currentUsers':
                        this.$store.commit('setCurrentUsers', {'currentUsers': data.currentUsers});
                        break;
                    case 'change_section':
                        this.$store.commit('setSection', {'section': data.section});
                        this.$wApi.Close();
                        // window.location.href = "https://web.xuezhi.app/#/";
                        // console.log(1);
                        // window.location.href = "http://localhost:8080/#/";
                        // console.log(2);
                         window.location.reload();
                        break;
                    case 'change_section_error':
                        break;
                    case 'finished_update_employeePower':

                        break;
                }
            },
        }
    }
</script>


